export const seo = {
  __default__: {
    nl: {
      title: 'srprs.me - Verken het onbekende, ga op verrassingsreis.',
      description:
        'Ga op reis met je bestemming als verrassing en maak op je vakantie het onverwachte onvergetelijk.',
      imageUrl: 'https://store.cdn.srprs.me/og-home.png',
    },
    uk: {
      title: 'srprs.me - Go on a city break to destination unknown',
      description:
        'Travel to destination unknown and make the unexpected truly unforgettable on your holiday.',
      imageUrl: 'https://store.cdn.srprs.me/og-home.png',
    },
    dk: {
      title: 'srprs.me - Tag på storbyferie til destination ukendt',
      description:
        'Rejs til destination ukendt og gør det uforventede til det uforglemmelige på din ferie.',
      imageUrl: 'https://store.cdn.srprs.me/og-home.png',
    },
  },
  how: {
    nl: {
      title: 'Hoe werkt het? De verrassingsreis van srprs.me',
      description:
        'Benieuwd naar hoe een verrrasingsreis in zijn werk gaat? Stel gemakkelijk je trip samen en ga op citytrip met je bestemming als verrassing.',
    },
    uk: {
      title: 'How does it work? A surprise trip with srprs.me',
      description:
        'Curious about how a surprise trip works? Easily customise your trip and go on a city break to destination unknown.',
    },
    dk: {
      title: 'Hvordan fungerer det? En surprise rejse med srprs.me',
      description:
        'Nysgerrig omkring hvordan en surprise rejse virker? Sammensæt selv din rejse og tag på storbyferie til destination ukendt.',
    },
  },
  trips: {
    nl: {
      title: 'Alle srprs.trips voor jou op een rijtje gezet',
      description:
        'Er zijn ontelbaar veel manieren om op een verrassingsreis te gaan. Kies welke srprs.trip het beste bij jou past en laat je verrassen.',
    },
    uk: {
      title: 'All our trip options are listed for you',
      description:
        'There are countless ways to customise your surprise journey. Choose which srprs.trip suits you best and be surprised.',
    },
    dk: {
      title: 'Alle vores rejsetemaer til dig',
      description:
        'Der er utallige måder at sammensætte din rejse. Vælg hvilken srprs.trip passer dig bedst og bliv overrasket.',
    },
  },
  about: {
    nl: {
      title: 'srprs.me - De expert in verrassingsreizen',
      description:
        'Leer srprs.me kennen. Stap in een open avontuur en ontmoet de reisconsultants die jouw vakantie boeken. ',
    },
    uk: {
      title: 'srprs.me - The experts in surprise holidays',
      description:
        'Get to know srprs.me. Embark on a surprise adventure and meet the travel consultants who will book your holiday.',
    },
    dk: {
      title: 'srprs.me - Eksperten i overraskelsesrejser',
      description:
        'Lær srprs.me at kende. Begiv dig ud på et overraskelseseventyr og mød rejsekonsulenterne der vil booke din rejse.',
    },
  },
  service: {
    nl: {
      title: 'Klantenservice srprs.me - Voor al jouw vragen',
      description:
        "Heb je een vraag, klacht of compliment? Onze collega's helpen je graag! Dus neem gerust contact ons op.",
    },
    uk: {
      title: 'Customer service @ srprs.me - for all your questions',
      description:
        'Do you have a question, complaint or a compliment for us? Our colleagues are happy to help! Please feel free to reach out to us. ',
    },
    dk: {
      title: 'Kundeservice @ srprs.me - til alle dine spørgsmål',
      description:
        'Har du et spørgsmål eller ris og ros til os? Vores kollegaer hjælper gerne! Bare tag fat i os.',
    },
  },
  giftcard: {
    nl: {
      title: 'Cadeaubon van srprs.me',
      description:
        'Verras je geliefde, vrienden of familie met de giftcard van srprs.me. Dit is niet zomaar een cadeaubon, maar een voorsprong op een onvergetelijke reis.',
    },
    uk: {
      title: 'Giftcard for a surprise trip - srprs.me',
      description:
        'Surprise your loved one, friends or family with a srprs.giftcard. This is not just a gift voucher, but a head start on an unforgettable journey.',
    },
    dk: {
      title: 'Gavekort til en overraskelsesrejse - srprs.me',
      description:
        'Overrask en elsket, venner eller familie med et srprs.gavekort. Det er ikke bare en gavekupon, det er starten på en uforglemmelig rejse.',
    },
  },
  conditions: {
    nl: {
      title: 'Verzilver je cadeaubon van srprs.me',
      description:
        'Cadeaubon gekregen? Verzilver hier je 6-cijferige code en ontdek wat dit onbekende cadeau voor jou in petto heeft. ',
    },
    uk: {
      title: 'Redeem your srprs.me giftcard',
      description:
        'Got a gift voucher? Redeem your 6-digit code here and discover what this unknown gift has in store for you.',
    },
    dk: {
      title: 'Indløs dit srprs.me gavekort',
      description:
        'Har du fået et gavekort? Indløs din kode her og find ud af, hvad denne ukendte gave har i vente til dig.',
    },
  },
  flycustomise: {
    nl: {
      title: 'Stel je vliegreis samen - srprs.me',
      description:
        'Stel je vliegreis samen en geef je voorkeuren aan. Wij regelen graag een fantastische reiservaring voor je. ',
    },
    uk: {
      title: 'Put together your trip - srprs.me',
      description:
        'Choose your flight options and state your preferences. We will be over the moon to arrange a fantastic travel experience for you.',
    },
    dk: {
      title: 'Sammensæt din rejse - srprs.me',
      description:
        'Vælg dine flypræferencer og tilføj dine ønsker. Vi er så klar på at arrangere en fantastisk rejseoplevelse til dig.',
    },
  },
  'in-control': {
    nl: {
      title: 'In Control - Meer controle over jouw citytrip met srprs.me',
      description:
        'Ga op citytrip naar een van deze 15 te gekke steden. Een verrassingsreis met iets meer controle, maar je bestemming blijft nog steeds een verrassing.',
    },
    uk: {
      title: 'In Control - More control over your city break with srprs.me',
      description:
        'Go on a city trip to one of these 15 crazy cities. A surprise trip with a little more control, but your destination still remains a surprise.',
    },
    dk: {
      title: 'In Control - Mere kontrol over din storbyferie med srprs.me',
      description:
        'Tag på en storbyferie til en af disse 15 lækre byer. En overraskelsesrejse med lidt mere kontrol, men din destination er stadig en overraskelse.',
    },
  },
  'solo-together': {
    nl: {
      title: 'Solo Together - Solo op een srprs.me citytrip met een groep',
      description:
        'Ontdek je reisgezelschap en bestemming pas bij vertrek. Ga samen in je eentje op citytrip met je bestemming als verrassing.',
    },
  },
  'beste-prijs': {
    nl: {
      title: 'Jouw verrassingsreis voor de beste prijs - srprs.me',
      description:
        'Wil je op citytrip voor de beste prijs? Vind hier de beste deal voor jouw verrassingsreis en vlieg naar een verrassende bestemming. ',
    },
    uk: {
      title: 'Your srprs.trip for the best price - srprs.me',
      description:
        'Do you want to go on a city trip for the best price? Find the best deal for your surprise trip here and fly to destination unknown.',
    },
    dk: {
      title: 'Din srprs.trip til den bedste pris - srprs.me',
      description:
        'Vil du afsted på en storbyferie til den bedste pris? Find det bedste tilbud på din overraskelsesrejse her og fly afsted mod destination ukendt.',
    },
  },
  favoriet: {
    nl: {
      title: 'De favoriete verrassingsreis met het vliegtuig - srprs.me',
      description:
        'Dit is de populairste samenstelling van een vliegreis onder onze reizigers. Kies voor de favoriete srprs.reis.',
    },
    uk: {
      title: 'Our travellers favourite srprs.trip - srprs.me',
      description:
        'This is the most popular option amongst our travellers. Choose your favourite srprs.trip',
    },
    dk: {
      title: 'Vores rejsendes yndlings srprs.trip - srprs.me',
      description:
        'Dette er det populæreste vælg af vores rejsende. Vælg din favorit srprs.trip',
    },
  },
  login: {
    nl: {
      title: 'My srprs login - srprs.me',
      description:
        'Vind al je reisgegevens in de my-srprs omgeving. Je bestemming blijft een verrassing tot vertrek.',
    },
    uk: {
      title: 'My srprs login - srprs.me',
      description:
        'Find all your travel data in the my-srprs area. Your destination will remain a surprise until departure.',
    },
    dk: {
      title: 'Min srprs login - srprs.me',
      description:
        'Find alle dine rejseoplysninger i min-srprs omgivelserne. Din destination er en overraskelse indtil afrejse.',
    },
  },
  driveCustomise: {
    nl: {
      title: 'Stel je autoreis samen - srprs.me',
      description:
        'Stel je autoreis samen en geef je voorkeuren aan. Wij regelen graag een fantastische reiservaring voor je. ',
    },
  },
  'multi-city': {
    nl: {
      title: 'Multi-City - Ontdek meerdere steden in één srprs.citytrip',
      description:
        'Ga op de verrassingreis Multi-City en combineer meerdere steden in één citytrip. ',
    },
  },
  broke: {
    nl: {
      title: 'Broke Citytrip - srprs.me',
      description:
        'Boek deze trip en maak kans op een mega upgrade en naar een stad buiten Europa.',
    },
  },
  train: {
    nl: {
      title: 'Train trip - srprs.me',
      description:
        'De trein! Niet op het verkeer letten en op een milieuvriendelijk manier op mooie plekken komen.',
    },
  },
  'lead-campaign-2-landing': {
    nl: {
      title: 'Win een srprs.abonnement!',
      description:
        'Haal die bucketlist maar tevoorschijn, want misschien kun jij binnenkort iets afstrepen… Win een reis naar één van de bestemmingen op je bucketlist!',
      canonicalPage: 'leadLanding',
    },
    uk: {
      title: 'Win a srprs.subscription!',
      description:
        "Make sure you have your bucket list at hand, maybe you're crossing something off very soon…Win a trip to one of your bucket list destinations!",
      canonicalPage: 'leadLanding',
    },
    dk: {
      title: 'Vind en Multi City-tur!',
      description:
        'Verden er en trekant, det ved vi alle. Hvis du kigger igennem kikkerten i retningen af hvert verdenshjørne, så vil du se enten sne, jungle eller et klart, blåt hav.',
      canonicalPage: 'leadLanding',
    },
  },
  'explore-new-cities': {
    nl: {
      title: 'New Places Citytrip - srprs.me',
      description:
        'Ontdek nieuwe bestemmingen met de New Places citytrip. Ga op verrassingsreis en vertrek naar een stad waar je nog nooit ben geweest. ',
    },
  },
  'drive-beste-prijs': {
    nl: {
      title: 'Verrassingsreis met de auto voor de beste prijs - srprs.me',
      description:
        'Wil je op citytrip voor de beste prijs? Vind hier de beste deal en vertrek met de auto naar een verrassende bestemming. ',
    },
  },
  'drive-favoriet': {
    nl: {
      title: 'De favoriete verrassingsreis met de auto - srprs.me',
      description:
        'Dit is de populairste samenstelling van een autoreis onder onze reizigers. Kies voor de favoriete srprs.reis.',
    },
  },
  'multi-drive': {
    nl: {
      title: 'Multi-Roadtrip - Ontdek meerdere steden in één srprs.trip',
      description:
        'Ga op de Multi-Roadtrip en combineer meerdere steden in één verrassende trip.',
    },
  },
  ultimate: {
    nl: {
      title: 'Roadtrip XL - De ultieme autoreis - srprs.me',
      description:
        'Ga op de ultieme autoreis en haal alles uit je roadtrip. Ga naar zeven bestemmingen in 14 dagen.',
    },
  },
  'Citytrip Worldwide': {
    nl: {
      title: 'Citytrip WorldWide - srprs.me',
      description:
        'Ga op 7-daagse citytrip naar een stad aan de andere kant van de wereld. Naar welk werelddeel vertrek jij met deze verrassingsreis?',
    },
  },
  LGBT: {
    nl: {
      title: 'LGBT-vriendelijke citytrip - srprs.me',
      description:
        'Op stedentrip naar een LGBT-vriendelijke hotspot in Europa? Ga op verrassingsvakantie naar een bestemming waar je helemaal jezelf kunt zijn. ',
    },
  },
  'srprs.kids': {
    nl: {
      title: 'Met kinderen op verrassingsreis - srprs.me',
      description:
        'Ontdek hoe het is om met je kinderen op verrassingsreis te gaan en maak het onverwachte pas echt onvergetelijk op bestemming onbekend. ',
    },
  },
  'srprs.paps/mama': {
    nl: {
      title: 'Met je ouders op verrassingsreis - srprs.me',
      description:
        'Ga samen op reis met jullie bestemming als verrassing. Neem je vader of moeder mee en stap in het vliegtuig voor een weekend met elkaar.',
    },
  },
}
